import { useContext } from 'react';
import { NotificationContext } from '../contexts/NotificationContext';

export const useNotifier = () => {
  const context = useContext(NotificationContext);
  if (context === undefined) {
    throw new Error('useNotifier must be used within a NotificationProvider');
  }
  // We only expose showNotification, hideNotification is managed internally or via the component
  // If direct hide access is needed, it can be exposed too.
  return { showNotification: context.showNotification };
};